const sales = (state = null, action) => {
  switch (action.type) {
    case "SET_SALES":
      return action.payload;
    default:
      return state;
  }
};

export default sales;
